import { render, staticRenderFns } from "./labor.vue?vue&type=template&id=3ff09d50&scoped=true&"
import script from "./labor.vue?vue&type=script&lang=js&"
export * from "./labor.vue?vue&type=script&lang=js&"
import style0 from "./labor.vue?vue&type=style&index=0&id=3ff09d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff09d50",
  null
  
)

export default component.exports